import script from "./web-knowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./web-knowledge.vue?vue&type=script&setup=true&lang=js"

import "./web-knowledge.vue?vue&type=style&index=0&id=d5acd1fc&lang=scss"

const __exports__ = script;

export default __exports__